document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('.product-form');
  if (!productForm) return;

  // Detectar cambios en las opciones de color
  const colorOptions = productForm.querySelectorAll('input[type="radio"][name*="Color"], input[type="radio"][name*="color"]');
  
  colorOptions.forEach(option => {
    option.addEventListener('change', function() {
      if (this.checked) {
        const selectedColor = this.value.toLowerCase().trim();
        switchToColorImage(selectedColor);
      }
    });
  });
  
  function switchToColorImage(color) {
    // Buscar todas las imágenes del producto
    const productImages = document.querySelectorAll('.product__media img');
    let targetIndex = -1;
    
    productImages.forEach((img, index) => {
      const altText = (img.alt || '').toLowerCase();
      
      // Si el alt text contiene el color seleccionado
      if (altText.includes(color)) {
        targetIndex = index;
      }
    });
    
    // Si encontramos la imagen, hacer clic en su thumbnail
    if (targetIndex >= 0) {
      const thumbnails = document.querySelectorAll('.product__media-toggle');
      if (thumbnails[targetIndex]) {
        thumbnails[targetIndex].click();
      }
    }
  }
});


